import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { googleMapApiKey } from '@/constants/config';
var moment = require("moment");

export default {
  	//props: ["VehicleId"],
    components: {          
    },
    filters: {            
    },
    data() {
      return {        
        ShowVehiclePositionModel: false,
      	LastVehiclePosition: {},
      	center: { 
       		lat: 55.232753,
       		lng: -3.944403
      	},
      	locationMarkers: [],
      	VehicleId: 0,
      };
    },   
    mounted() {      
      this.VehicleId = this.$route.params.VehicleId;  
      //this.ShowVehicleMaps();      
    },
    computed: {    	   		
  	},
    methods: {  
      SetVehicleId(VehicleId){
      	this.VehicleId = VehicleId;
      },
      ShowVehicleMaps(type = ""){ 
      	this.locationMarkers=[];      	
      	this.$swal.fire({
			title: "Fetching data...",	          
			text: "Please wait...",	          
			showConfirmButton: false,
			allowOutsideClick: false,
	    });
        Axios.post(Endpoints.Vehicle.GetInseegoVehiclePosition, {token: localStorage.getItem("token"),vehicle_id: this.VehicleId,}).then((Response) => {          
          if (Response.data.success) {
          	this.lastUpdatedPosition =  Response.data.lastUpdateTime
          	this.LastVehiclePosition = Response.data.LastVehiclePosition;
          	//we can also fetch the location lat/long by following api
          	//Axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+this.LastVehiclePosition.Location+'&key='+googleMapApiKey).then((Response) => {})      		
          	if(this.LastVehiclePosition.Location){ 
          		const marker = {
          			lat: this.LastVehiclePosition.Latitude,
          			lng: this.LastVehiclePosition.Longitude
        		};		        		
        		this.locationMarkers.push({ position: marker });        		
        		this.center = marker;
        		this.ShowVehiclePositionModel = true;
        		this.$swal.close();
        		Axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+this.LastVehiclePosition.Latitude+','+this.LastVehiclePosition.Longitude+'&key='+googleMapApiKey).then((Response) => {        			
        			if(Response.data && Response.data.results && Response.data.results[0]){
        				this.LastVehiclePosition.Location = Response.data.results[0]['formatted_address']
        			}
        		})      		         		          	
	      	}else{
	      		this.$swal.fire({
					title: "Oops!",
					text: 'Error in Getting Vehicle Location',
					icon: "error",
					confirmButtonText: "Close",
            	});
	      	}
            
          }else{          	
          	this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },      

    },
  };
